import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL  = "https://mdqlzhtwkanzjvylfjxn.supabase.co";
// Publishable key (sb_publishable_...) comes from the build environment
// (Vercel: VITE_SUPABASE_PUBLISHABLE_KEY). No fallback: fail loudly if it's missing.
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('App misconfigured: VITE_SUPABASE_PUBLISHABLE_KEY is not set. Add it to the environment and rebuild.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

export async function callEdgeFunction(functionName, body) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');

  let res;
  try {
    res = await fetch(`${SUPABASE_URL}/functions/v1/${functionName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
        'apikey': SUPABASE_PUBLISHABLE_KEY,
      },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error('Could not reach the server. Check your connection and try again.');
  }

  // Read as text first: a failing function can answer with a plain-text body, and
  // parsing that as JSON used to throw a syntax error that buried the real cause.
  const raw = await res.text();
  let data = null;
  try { data = raw ? JSON.parse(raw) : null; } catch { /* not JSON — keep raw */ }

  if (!res.ok) {
    throw new Error(data?.error || raw || `${functionName} failed (${res.status})`);
  }
  return data ?? {};
}
